module.exports = __webpack_public_path__ + "img/pago.29bd9e9e.png";